import serverCall from "../../serverCall";






const getAllUser = (adminId, page, limit, search) => {
  try {
    const q = encodeURIComponent(search ?? "");
    const response = serverCall.get(
      `/admin/get-all-user?adminId=${adminId}&page=${page}&limit=${limit}&search=${q}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getUserDetails = (userId) => {
  try {
    const response = serverCall.get(`/admin/get-user?userId=${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const createUser = (body) => {
  try {
    const response = serverCall.post(`/admin/create-user`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateUser = (userId, body) => {
  try {
    const response = serverCall.patch(
      `/admin/update-user?userId=${userId}`,
      body
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteUser = (userId) => {
  try {
    const response = serverCall.delete(`/admin/delete-user?userId=${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateAdminProfile = (body, userId) => {
  try {
    const response = serverCall.patch(`/admin/update-profile`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const adminFileUpload = (body, config = {}) => {
  try {
    const response = serverCall.post(`/company/update-company`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      ...config, // Spread the config here to include options like onUploadProgress
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getCompany = () => {
  try {

    const response = serverCall.get(`/company/get-companies`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getIndividualdock = () => {
  try {
    const response = serverCall.get(`/company/get-individual-docs`);
    return response;
  } catch (error) {
    throw error;
  }
};

const UserService = {
  getAllUser,
  getUserDetails,
  createUser,
  updateUser,
  deleteUser,
  updateAdminProfile,
  adminFileUpload,
  getCompany,
  getIndividualdock
};

export default UserService;
